import ContainerCustom from "../../../Components/ContainerCustom";
import Table from "../../../Components/Table/Table";
import TableButton from "../../../Components/Buttons/TableButton";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { useState, useEffect } from "react";
import ModalSimple from "../../../Components/ModalSimple";
import AnnouncementModalEdit from "./AnnouncementModalEdit";
import { API_BASE_URL } from "../../../config/api";

export default function AnnouncementsList() {
  const [activeFilter, setActiveFilter] = useState([true, true]);
  const [selectedNotif, setSelectedNotif] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [notifData, setNotifData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const fetchNotifData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/notifications/admin/announcements/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/notifications/admin/announcements/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setNotifData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    fetchNotifData();
  }, []);

  useEffect(() => {
    if (!notifData) {
      setTableData([]);
      return;
    }

    const filtered = notifData
      .filter((item) => {
        if (item.display_to_users === true && activeFilter[0]) return true;
        if (item.display_to_users === false && activeFilter[1]) return true;
        return false;
      })
      .map((notif) => ({
        uuid: notif.id,
        title: notif.title,
        status: notif.display_to_users ? "active" : "deactive",
        description: notif.description,
        detail: "",
      }));

    setTableData(filtered);
  }, [activeFilter, notifData]);

  return (
    <>
      <ContainerCustom
        header="لیست ‌اعلانات"
        headSVG="archive"
        search={false}
        filter={false}
        sort={false}
        colorfulFilterOptions={[
          {
            SVGName: "tick",
            text: "نمایش",
            className: "w-24",
            color: "green",
          },
          {
            SVGName: "failed",
            text: "عدم نمایش",
            className: "w-24",
            color: "red",
          },
        ]}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
      >
        <Table
          columns={[
            { key: "uuid", label: "کد اعلان" },
            { key: "title", label: "عنوان" },
            {
              key: "status",
              label: "وضعیت",
              render: (value) =>
                value === "active" ? (
                  <StatusColorful
                    SVGName="tick"
                    text="فعال"
                    className="w-24"
                    color="green"
                  />
                ) : value === "deactive" ? (
                  <StatusColorful
                    SVGName="failed"
                    text="عدم نمایش"
                    className="w-24"
                    color="red"
                  />
                ) : (
                  ""
                ),
            },
            {
              key: "detail",
              label: "جزئیات",
              render: (value, row) => (
                <TableButton
                  text="مشاهده"
                  href=""
                  onClick={() => {
                    setShowModal(true);
                    setSelectedNotif(row);
                  }}
                  className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
                />
              ),
            },
          ]}
          data={tableData && tableData.length > 0 ? tableData : []}
        />
      </ContainerCustom>
      {showModal && (
        <ModalSimple showModal={showModal} setShowModal={setShowModal}>
          <AnnouncementModalEdit
            onClose={() => setShowModal(false)}
            notif={selectedNotif}
          />
        </ModalSimple>
      )}
    </>
  );
}
